import { useQuery } from "@tanstack/react-query";
// API
import API from "./Api";

const useGetInstallmentRequestsApi = () => {
  return useQuery({
    queryKey: ["installment-requests"],
    queryFn: async () => {
      const response = await API.get("/api/installment-requests");
      return response.data;
    },
  });
};

export default useGetInstallmentRequestsApi;
